import { Layout, SelectedDevice as SelectedDeviceComponent } from "components"
export const SelectedDevice = () => {
 return (
  <Layout>
   <SelectedDeviceComponent />
  </Layout>
 )
}
